var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTcsIconRaffle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83 91",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.4,-25.6)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.9,115.9H64.5c-0.9,0-1.6-0.7-1.6-1.7v-11.5h3.3v9.9h16.1v-9.7h3.3v11.3C85.5,115.1,84.8,115.9,83.9,115.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.2,102.7h-3.3V92.1c0-0.9,0.7-1.7,1.6-1.7h13.7v3.3H66.2V102.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.5,102.9h-3.3v-9.2h-4v-3.3h5.6c0.9,0,1.7,0.7,1.7,1.7V102.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.7,109.1c-1.3-1-2.6-2.1-3.7-3.3l2.4-2.3c1,1,2.1,2,3.3,2.9L38.7,109.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.8,92.8L74,87.6c-0.4-0.8-0.1-1.8,0.7-2.2l17.2-9c0.4-0.2,0.8-0.2,1.3-0.1c0.4,0.1,0.8,0.4,1,0.8l4.9,9.4L96.1,88 l-4.1-8l-14.3,7.4l2,3.8L76.8,92.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.7,108.1c-0.6,0-1.2-0.3-1.5-0.9l-1.8-3.5l2.9-1.5l1.1,2.1l5-2.6l1.5,2.9l-6.4,3.4C86.2,108,86,108.1,85.7,108.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.2,103.4l-3-1.4l1.4-2.8l-14.5-7l-0.5,1l-3-1.4l1.2-2.5c0.4-0.8,1.4-1.2,2.2-0.8l17.4,8.5c0.4,0.2,0.7,0.5,0.8,0.9 c0.1,0.4,0.1,0.9-0.1,1.3L60.2,103.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.3,
    y: 106.9,
    transform: "matrix(0.4368 -0.8996 0.8996 0.4368 -66.1873 111.3583)",
    width: 13,
    height: 3.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.7,93.3l-4.4-7.4l-5.1,3l-1.7-2.8l6.5-3.9c0.8-0.5,1.8-0.2,2.3,0.6l5.2,8.8L40.7,93.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.5,109.2l-1.7-2.8l7.1-4.2l-5.2-8.8l2.8-1.7l6.1,10.2c0.2,0.4,0.3,0.8,0.2,1.2c-0.1,0.4-0.4,0.8-0.8,1L40.5,109.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.7,
    y: 101,
    width: 5.8,
    height: 3.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.7,102.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 100.5,
    transform: "matrix(0.4367 -0.8996 0.8996 0.4367 -40.294 145.843)",
    width: 3.3,
    height: 9.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.4,104.6l-1.8-0.9c-0.8-0.4-1.2-1.4-0.8-2.2l7.3-14.9l3,1.4l-6.5,13.5l0.3,0.2L91.4,104.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.3,88.1l-7.6-3.7L99.1,88l-3-1.4l2.4-5c0.4-0.8,1.4-1.2,2.2-0.8l9,4.4L108.3,88.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.1,116.2H53.4c-0.2,0-0.3,0-0.5-0.1c-15.4-4.8-24.3-14.2-24.3-25.9c0-12.1,7.4-25.9,7.7-26.5c0.3-0.5,0.8-0.9,1.5-0.9 h64c0.6,0,1.2,0.3,1.5,0.9c0.3,0.6,7.7,14.9,7.7,26.5c0,11.5-9.1,21.2-24.3,25.9C86.5,116.2,86.3,116.2,86.1,116.2z M53.7,112.9 h32.2c13.6-4.3,21.7-12.8,21.7-22.7c0-9.2-5.3-20.8-6.9-24.1H38.8c-1.6,3.2-6.9,14.4-6.9,24.1C31.9,104,45.4,110.3,53.7,112.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.8,
    y: 45.5,
    className: "st0",
    width: 22.6,
    height: 29.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4,76.6H44.8c-0.9,0-1.6-0.7-1.6-1.7V45.5c0-0.9,0.7-1.6,1.6-1.6h22.6c0.9,0,1.6,0.7,1.6,1.6v29.5 C69.1,75.8,68.3,76.6,67.4,76.6z M46.4,73.3h19.3V47.1H46.4V73.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.5,59.4H96.1c-0.9,0-1.7-0.7-1.7-1.6V27.2c0-0.9,0.7-1.6,1.7-1.6h13.4c0.9,0,1.7,0.7,1.7,1.6v30.5 C111.1,58.6,110.4,59.4,109.5,59.4z M97.7,56.1h10.1V28.8H97.7V56.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.5,46l-2.3-2.3l10.7-10.7c2.8-2.8,6.5-4.3,10.5-4.3h22.7v3.3H73.3c-3.1,0-6,1.2-8.1,3.4L54.5,46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.2,40.7L52.1,56.8c-1.6,1.6-1.6,4.1,0,5.7l0,0c1.6,1.6,4.1,1.6,5.7,0l8.1-8.1c0.8-0.8,1.8-1.3,2.9-1.5 l4.2-0.6c3.9-0.6,7.6-2.4,10.4-5.3l4.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9,65.3c-1.5,0-2.9-0.6-4-1.7c-1.1-1.1-1.7-2.5-1.7-4c0-1.5,0.6-2.9,1.7-4L67,39.5c0.6-0.6,1.7-0.6,2.3,0 c0.6,0.6,0.6,1.7,0,2.3L53.2,58c-0.4,0.4-0.7,1-0.7,1.7c0,0.6,0.2,1.2,0.7,1.7c0.9,0.9,2.5,0.9,3.3,0l8.1-8.1c1-1,2.4-1.7,3.8-1.9 l4.2-0.6c3.6-0.5,6.9-2.2,9.5-4.8l4.4-4.4c0.6-0.6,1.7-0.6,2.3,0c0.6,0.6,0.6,1.7,0,2.3l-4.4,4.4c-3.1,3.1-7,5.1-11.3,5.7L69,54.6 c-0.7,0.1-1.4,0.5-2,1l-8.1,8.1C57.8,64.7,56.4,65.3,54.9,65.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.1,65.7c-0.5,0-1-0.2-1.3-0.7c-0.5-0.7-0.4-1.8,0.4-2.3l14-10.3c0.7-0.5,1.8-0.4,2.3,0.4c0.5,0.7,0.4,1.8-0.4,2.3 l-14,10.3C82.8,65.6,82.4,65.7,82.1,65.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcsIconRaffle);
export default __webpack_public_path__ + "static/media/tcs-icon_raffle.cb31f3e7c23472f01bfc44a8b7c4bd78.svg";
export { ForwardRef as ReactComponent };